import { resolveMedia } from "../../services/api";
import defaultAvatar from "../../assets/logo/logo.png";
import "../../styles/modal.css";

export default function TransactionDetailsModal({ tr, onClose }) {
  if (!tr) return null;

  const user = tr.user;
  const avatar = resolveMedia(user?.profilPicture, defaultAvatar);

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <div className="modalHeader">
          <img src={avatar} alt="avatar" className="modalAvatar" />
          <div>
            <div className="modalName">{user?.firstName} {user?.lastName}</div>
            <div className="modalRole">ID Transaction: {tr.id}</div>
          </div>
          <button className="modalClose" onClick={onClose}>✕</button>
        </div>

        <div className="modalSection">
          <h4 className="modalSectionTitle">Détails de la Transaction</h4>
          <div className="modalGrid">
            <Info label="Montant" value={`${tr.amount.toLocaleString()} CFA`} />
            <Info label="Type" value={tr.isOutgoing ? "Débit (Retrait)" : "Crédit (Recharge)"} />
            <Info label="Date" value={new Date(tr.created_at).toLocaleString('fr-FR')} />
            <Info label="Description" value={tr.description} />
          </div>
        </div>

        <div className="modalSection">
          <h4 className="modalSectionTitle">Infos Bénéficiaire</h4>
          <div className="modalGrid">
            <Info label="Username" value={user?.username} />
            <Info label="Contact" value={user?.contact?.tel || "N/A"} />
          </div>
        </div>
      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div className="infoItem">
      <span className="infoLabel">{label}</span>
      <span className="infoValue">{value || "-"}</span>
    </div>
  );
}